var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"accordion"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.beforeLeave,"leave":_vm.leave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContent),expression:"showContent"}],staticClass:"dg-accordion-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }